<template>
	<el-container class="layout">
		<!-- 导航栏 -->
		<el-header class="header herder_bar" v-if="!hideHeader">
			<header-bar :collapsed="collapsed" @collapsed-change="handleCollpasedChange">
				<!-- <bread-crumb></bread-crumb> -->
			</header-bar>
		</el-header>
		<el-container class="body">
			<!-- <el-scrollbar style="width:100%"> -->
			<!-- 菜单栏 -->
			<el-aside class="aside" width="auto" v-if="!hideAside">
				<side-bar :collapsed="collapsed" :menu="$store.state.user.menu"></side-bar>
			</el-aside>
			<el-container class="container">
				<!-- 主要页面 -->
				<el-scrollbar style="width:100%">
					<!-- 标签栏 -->
					<!-- <div class="nav header" v-if="!hideHeader"> -->
					<!-- <tag-nav :route="$route"></tag-nav> -->
					<!--<bread-crumb></bread-crumb>-->
					<!-- </div> -->
					<!-- 该页面标题 -->
					<div class="main_title" v-if="$route.meta.title">{{$t($route.meta.title)}}</div>
					<!-- <div class="main_title">{{$route.meta.title}}</div> -->
					<el-main class="content">
						<transition name="fade-transform" mode="out-in">
							<!-- 二级菜单以上的在组件默认不缓存，需要缓存要在具体组件里添加。防止二级菜单和三级菜单缓存混合，导致出错 -->
							<router-view v-if="$route.matched.length > 2"></router-view>
							<!-- 一级菜单和二级菜单的组件都缓存，不需要缓存的自行添加到“缓存忽略名单”里 -->
							<keep-alive v-else :exclude="excludeList">
								<router-view />
							</keep-alive>
						</transition>
					</el-main>
				</el-scrollbar>
			</el-container>
			<!-- </el-scrollbar> -->
		</el-container>
	</el-container>
</template>

<script>
import SideBar from './sidebar';
import HeaderBar from './header-bar';
// import BreadCrumb from './bread-crumb';
// import TagNav from './tag-nav';
import { mapState } from 'vuex';
import { KEEP_ALIVE_EXCLUDE_LIST } from '@/config/constant';
import config from '@/config';
export default {
	name: 'layout',
	data() {
		return {
			zhaonaxue: false,
			collapsed: false,
			state: '全部学校',
			timer: null,
			excludeList: KEEP_ALIVE_EXCLUDE_LIST
		};
	},
	computed: {
		...mapState({
			hideAside: state => state.app.query.hide_aside,
			hideHeader: state => state.app.query.hide_header
		})
	},
	created() {
		if (window.location.hostname === config.hostName) {
			this.zhaonaxue = true;
		}
	},
	methods: {
		/**
		 * 控制sidebar
		 */
		handleCollpasedChange(state) {
			this.collapsed = state;
		}
	},
	components: {
		SideBar,
		HeaderBar
		// TagNav,
		// BreadCrumb
	}
};
</script>

<style lang="scss" scoped>
.layout {
	min-width: 1500px;
	height: 100%;
	// overflow: scroll;
	background-color: #fff;
	.header {
		background: #ffffff;
		&.herder_bar {
			border-bottom: 1px solid #ebebeb;
		}
	}
	.body {
		height: 90%;
		width: 100%;
		.aside {
			background-color: $-background-sidbar;
			box-shadow: 4px 0px 12px 0px rgba(0, 0, 0, 0.06);
			z-index: 999;
		}
		.main_title {
			margin: 40px;
			margin-bottom: 20px;
			min-width: 1000px;
			font-size: 24px;
			font-weight: 400;
			color: #333;
		}
	}
	.content {
		min-width: 1000px;
		background-color: #fff;
		padding: 0;
		margin: 0 40px;
		overflow-x: hidden;
		min-height: 80vh;
	}
}
</style>
<style lang="scss">
/**  禁止el-scrollbar出现横向滚动条*/
.el-scrollbar__thumb {
	width: 0px !important;
	overflow-x: hidden;
	display: none;
	&::-webkit-scrollbar {
		display: none;
	}
}
.container {
	.el-scrollbar__wrap {
		overflow: auto;
		margin-right: 0 !important;
		min-width: 100px;
	}
}
::-webkit-scrollbar-track {
	border-radius: 0;
}
::-webkit-scrollbar {
	-webkit-appearance: none;
	width: 10px;
	height: 10px;
}
::-webkit-scrollbar-thumb {
	cursor: pointer;
	border-radius: 5px;
	background: rgba(144, 147, 153, 0.3);
	transition: color 0.2s ease;
}
</style>
